import {useTitle} from 'hooks';
import {NavbarCommon} from 'components';
import FormResetPassword from './components/Form.ResetPassword';

interface IPageResetPasswordProps {}

const PageResetPassword = ({}: IPageResetPasswordProps) => {
  useTitle('Reset Password');
  return (
    <div className="min-h-screen flex flex-col">
      <NavbarCommon />
      <FormResetPassword />
    </div>
  );
};

export default PageResetPassword;
